import { basicInitialState } from '../_utils/basicInitialState';
import { TSearchState } from './searchModel';

export const searchInitialState: TSearchState = {
  ...basicInitialState,
  searchQuery: '',
  searchResults: []
};
